import React from 'react';

import AdminCrawlersPage from '../../screens/AdminCrawlersPage/AdminCrawlersPage.component';

const AdminCrawlers: React.FC = () => <AdminCrawlersPage />;

export default AdminCrawlers;
